import { client } from '../client';
import { Organization } from './types/UserProfile';

export const getMyOrganizations = async (): Promise<Organization[]> => {
  const { data } = await client.get('/organizations');

  return data;
};
